import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IDataCardFE } from '../../../../../models/data-card.model'
import { HelperService } from '../../../../../services/helper.service'
import { NotificationsDataCardModalComponent } from '../../cmms-components/notifications-data-card-modal/notifications-data-card-modal.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
    selector: 'app-data-fd',
    templateUrl: './data-fd.component.html',
    standalone: false
})
export class DataFdComponent {
  @Input() data: IDataCardFE
  @Input() ttmURLParams: any
  @Input() filter?: {startTime?: string; endTime?: string}
  @Input() hasCMMSPackage: boolean = false
  @Input() hasRCAFPackage: boolean = false

  @Output() openSDLEvent: EventEmitter<string> = new EventEmitter()

  constructor(private modalService: NgbModal) {}

  public parseValue(value: any): string {
    return HelperService.getColorBulletHTML(value, '')
  }

  public getSIFParams(mo: string, isFE: boolean = false): any {
    return {
      filter: JSON.stringify(
        HelperService.getObjectWithoutNullValues({
          trigger: !isFE ? mo : null,
          feElem: isFE ? mo : null,
        }),
      ),
    }
  }

  public onOpenNotificationModal(tag: string): void {
    const modalRef = this.modalService.open(NotificationsDataCardModalComponent, {
      windowClass: 'cmms-notification-modal-z2000',
      backdropClass: 'cmms-notification-backdrop-z2000',
    })
    modalRef.componentInstance.mainObject = tag
  }

  public displayNotificationIcon(notificationStatus?: number): boolean {
    return this.hasCMMSPackage && (notificationStatus === -1 || notificationStatus === 1)
  }

  public hasUrlBadges(type: 'MO' | 'C1'): boolean {
    switch (type) {
      case 'C1':
        return !!(
          this.data &&
          (this.data.Component_Dev_Active_1 ||
            this.data.Component_Dev_InActive_Count_1 ||
            this.data.Component_Flt_Active_1 ||
            this.data.Component_Flt_InActive_Count_1 ||
            this.data.Component_Ovr_Active_1 ||
            this.data.Component_Ovr_InActive_Count_1 ||
            this.data.Component_Dmd_Active_1 ||
            this.data.Component_Dmd_InActive_Count_1)
        )
      default:
        return !!(
          this.data &&
          (this.data.Object_Dev_Active ||
            this.data.Object_Dev_InActive_Count ||
            this.data.Object_Flt_Active ||
            this.data.Object_Flt_InActive_Count ||
            this.data.Object_Ovr_Active ||
            this.data.Object_Ovr_InActive_Count)
        )
    }
  }

  public hasCurrentRating(currentRating: any): boolean {
    return !HelperService.isNullOrUndefined(currentRating)
  }

  public getSDLs(sdl?: string): string[] {
    if (sdl) {
      return sdl.split(',').map((item: string) => item.trim())
    }
    return []
  }

  public onOpenSDL(sdl: string): void {
    this.openSDLEvent.next(sdl)
  }
}


